import React from 'react';
import {
	ArrayInput, AutocompleteInput, BooleanField,
	Datagrid,
	DateField,
	FormTab, ReferenceInput,
	ReferenceManyField,
	SelectField, SimpleFormIterator,
	TextField, TextInput, TopToolbar, useGetOne, useRecordContext, useResourceContext,
} from 'react-admin';
// eslint-disable-next-line import/no-extraneous-dependencies
import { RecordContextProvider } from 'ra-core';
import { reviewStatusChoices } from '../Review';
import { WithMasterPermissions } from '../../DataProviderExtension/authExtension';
import EditInDialogButton from '../../components/dialogs/EditInDialogButton';
import { ClonePromotionButton, PromotionForm } from '../Promotion';
import CreateInDialogButton from '../../components/dialogs/CreateInDialogButton';

export const catalogStatus = [
	{ id: 'active', name: 'Включен в каталог' },
	{ id: 'suspended', name: 'Приостановлен' },
];

export const versionStatus = [
	{ id: 'published', name: 'Опубликована' },
	{ id: 'moderating', name: 'На модерации' },
	{ id: 'editing', name: 'На редактировании' },
];

export const AddPromotionButton = () => {
	const record = useRecordContext();
	return (
		<CreateInDialogButton
			fullWidth
			maxWidth="xl"
			record={{ business: { id: record.id }, suspended: true }}
		>
			<PromotionForm />
		</CreateInDialogButton>
	);
};

export const LocationInput = (props) => (
	<ArrayInput {...props}>
		<SimpleFormIterator>
			<ReferenceInput
				label="Локация"
				reference="Location"
				sort={{ field: 'label', order: 'ASC' }}
				allowEmpty
				filterToQuery={(searchText) => ({ label: searchText })}
			>
				<AutocompleteInput
					optionText="label"
					emptyText="Не выбран"
				/>
			</ReferenceInput>
		</SimpleFormIterator>
	</ArrayInput>
);

export const BusinessReviewTab = (props) => {
	const record = useRecordContext();
	const resource = useResourceContext();
	const {
		isLoading: isMainRecordLoading, data,
	} = useGetOne(resource, { id: record.mainVersion?.id || record.id });
	if (isMainRecordLoading || !data) {
		return null;
	}
	return (
		<FormTab {...props} label="Отзывы">
			<RecordContextProvider value={data}>
				<ReferenceManyField label="Акции" reference="Review" target="business">
					<Datagrid rowClick="show" bulkActionButtons={false}>
						<TextField label="Адрес" source="address" />
						<TextField label="Имя пользователя" source="name" />
						<TextField label="Рейтинг" source="rating" />
						<TextField label="Текст сообщения" source="message" />
						<DateField label="Дата визита" source="dateOfVisit" />
						<DateField label="Дата отправки" source="dateWrittenRating" showTime />
						<SelectField label="Статус" source="statusMessage" choices={reviewStatusChoices} />
					</Datagrid>
				</ReferenceManyField>
			</RecordContextProvider>
		</FormTab>
	);
};

export const BusinessPOSFormTab = (props) => {
	return (
		<FormTab {...props} label="Магазины/Офисы">
			<ArrayInput label="Магазины/Офисы" source="pos">
				<SimpleFormIterator>
					<TextInput label="Название" source="title" />
					<TextInput label="Часы работы" source="hours" />
					<TextInput fullWidth label="Адрес (на форме)" source="address.show" />
					<TextInput fullWidth label="Адрес (для поиска)" source="address.nav" />
					<TextInput label="Широта" source="address.lat" />
					<TextInput label="Долгота" source="address.lon" />
					<LocationInput label="Локации" source="address.locationIds" />
					<ArrayInput label="Телефоны" source="phones">
						<SimpleFormIterator>
							<TextInput label="На форме" source="show" />
							<TextInput label="Для набора" source="dial" />
						</SimpleFormIterator>
					</ArrayInput>
					<TextInput label="VK" source="social.vk" />
					<TextInput label="Instagram" source="social.inst" />
					<TextInput label="Facebook" source="social.fb" />
					<TextInput label="Youtube" source="social.yt" />
					<TextInput label="OK" source="social.ok" />
				</SimpleFormIterator>
			</ArrayInput>
		</FormTab>
	);
};

export const BusinessPromotionTab = (props) => {
	const record = useRecordContext();
	const resource = useResourceContext();
	const {
		isLoading: isMainRecordLoading, data,
	} = useGetOne(resource, { id: record.mainVersion?.id || record.id });
	if (isMainRecordLoading || !data) {
		return null;
	}
	return (
		<FormTab {...props} label="Акции">
			<RecordContextProvider value={data}>
				<ReferenceManyField label="Акции" reference="Promotion" target="business">
					<div>
						<TopToolbar>
							<AddPromotionButton />
						</TopToolbar>
						<Datagrid bulkActionButtons={false} rowClick="edit">
							<DateField label="Дата начала" source="startDate" />
							<DateField label="Дата окончания" source="finishDate" />
							<TextField label="Краткое описание" source="offer.short" />
							<BooleanField label="Приостановлена" source="suspended" />
							<WithMasterPermissions>
								<EditInDialogButton fullWidth maxWidth="xl">
									<PromotionForm />
								</EditInDialogButton>
								<ClonePromotionButton />
							</WithMasterPermissions>
						</Datagrid>
					</div>
				</ReferenceManyField>
			</RecordContextProvider>
		</FormTab>
	);
};
